<template>
  <div class="card">
    <h2>Entrar</h2>
    <div class="row">
      <div class="col">
        <label>Usuario o email</label>
        <input class="input" v-model="usernameOrEmail" autocomplete="username">
      </div>
      <div class="col">
        <label>Contraseña</label>
        <input class="input" type="password" v-model="password" autocomplete="current-password">
      </div>
    </div>
    <div style="margin-top:12px;">
      <button class="btn" @click="submit" :disabled="loading">{{ loading ? 'Entrando...' : 'Entrar' }}</button>
      <router-link to="/register" style="margin-left:12px;">Crear cuenta</router-link>
    </div>
    <p v-if="error" style="color:#c92a2a;margin-top:10px;">{{ error }}</p>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data: () => ({ usernameOrEmail: '', password: '', loading: false, error: null }),
  methods: {
    ...mapActions(['login']),
    async submit() {
      this.error = null; this.loading = true;
      try {
        await this.login({ usernameOrEmail: this.usernameOrEmail, password: this.password });
        const redirect = this.$route.query.redirect || '/';
        this.$router.replace(redirect);
      } catch (e) {
        this.error = (e.response && e.response.data && e.response.data.error) || 'Error al iniciar sesión';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
